import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate as useHistory } from 'react-router-dom'

import { PageTitle, Button, buttonModes, buttonTypes, Icon, iconNames, AccessControl } from '../../../components'
import { attributesNames, userRightTypes, routePaths } from '../../../constants'
import { Logger, LoggerTypes } from '../../../utils'
import { GlobalAttributeTabsDialog } from '../../globalAttributes'
import './style.scss'

/**
 * @see https://v4.mui.com/components/buttons/#button
 * @returns {div}
 */
export const ProjectActionsBar = () => {
  const navigateTo = useHistory()
  const { t } = useTranslation()

  const [openGlobalDialog, setOpenGlobalDialog] = useState(false)

  const onCreateClick = () => {
    Logger.trace(LoggerTypes.CONTROLLER, 'ProjectActionsBar.onCreateClick()', {})

    navigateTo(routePaths.PROJECT_CREATE)
  }

  const onGlobalClick = () => {
    Logger.trace(LoggerTypes.CONTROLLER, 'ProjectActionsBar.onGlobalClick()')
    setOpenGlobalDialog(true)
  }

  const currentProject = null
  const currentScenario = null

  // Logger.trace(LoggerTypes.CONTAINER, 'ProjectActionsBar.render()')

  return (
    <div className="ProjectActionBar">
      <PageTitle title={t('Welcome')} />
      <p>{t('autoplan.explanation')}</p>

      <AccessControl userPermissions={[userRightTypes.PROJECT_READ]} renderNoAccess={() => <></>}>
        <footer>
          {/* -- Create a Project -- */}
          <AccessControl userPermissions={[userRightTypes.PROJECT_EDIT]} renderNoAccess={() => <></>}>
            <Button
              mode={buttonModes.PRIMARY_ACTION}
              type={buttonTypes.BUTTON}
              text={t('projects.create.head_buttons.create.text')}
              tooltip={t('projects.create.title')}
              icon={<Icon name={iconNames.PLUS} size={15} />}
              onClick={onCreateClick}
              className="createProject"
            />
          </AccessControl>

          {/* -- Global Attributes (list + create) -- */}
          <AccessControl
            userPermissions={[userRightTypes.GLOBAL_ATTRIBUTES_READ, userRightTypes.GLOBAL_ATTRIBUTES_EDIT]}
            renderNoAccess={() => <></>}
          >
            <Button
              mode={buttonModes.HEADER}
              type={buttonTypes.BUTTON}
              text={t('global.global_library_title')}
              tooltip={t('global.global_library_title')}
              icon={<Icon name={iconNames.GLOBALS} size={15} />}
              onClick={onGlobalClick}
            />
          </AccessControl>
        </footer>
      </AccessControl>

      {openGlobalDialog && (
        <GlobalAttributeTabsDialog
          currentProject={currentProject}
          currentScenario={currentScenario}
          tabValue={0}
          // -- MUST respect the tabs' order
          tabIdentifier={[
            attributesNames.RESOURCES, // 0
            attributesNames.PRODUCTS, // 1
            attributesNames.VARIABLES, // 2
            attributesNames.PARAMETERS, // 3
            attributesNames.WEATHER_DATA // 4
            // attributesNames.LOCATIONS // 5
          ]}
          setTabValue={() => {}}
          openDialog={openGlobalDialog}
          setOpenDialog={setOpenGlobalDialog}
          // -- MUST respect the order of appearance in the Global import popin
          tabVisible={{
            resources: true,
            products: true,
            variables: true,
            parameters: true,
            weather_data: true
            // locations: true
          }}
          // -- Object of array of objects that contain the selected items in the
          // -- Global import attribute popin
          selectedAttributes={null}
          isMargin={false}
        />
      )}
    </div>
  )
}
